export { TabTray as default } from "./tab-tray";
export type { TabTrayProps } from './tab-tray';
